import { isCssColor } from './isCssColor';
import { classToHex } from './classToHex';

export function convertToHex(color: string) : string {
	if (isCssColor(color)) {
		return color;
	}

	switch (color) {
		case 'white':
			return '#FFF';
		case 'black':
			return '#000';
		case 'transparent':
			return 'transparent';
		default:
			return classToHex(color);
	}
}
